<template>
  <div data-qa="price_clinic">
    <div
      class="text-h6 text--text mb-1"
      data-qa="price_clinic_num"
    >
      {{ getFormattedPrice(price) }}
    </div>
    <div
      v-if="price"
      class="text-caption text-secondary--text"
      data-qa="price_clinic_desc"
    >
      {{ t('Оплата в клинике', options) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { getFormattedPrice } from 'www/utils'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{ price?: number | null }>()
</script>
